import { useQuery } from "@tanstack/react-query";
import { useAPIClient } from "render/context/APIContext";
import { applySignal } from "./applySignal";

export function useECGDeviceQuery(pointer: {
  patientId: string;
  visitId: string;
}) {
  const api = useAPIClient();
  return useQuery({
    queryKey: ["ecg", pointer.patientId, pointer.visitId],
    queryFn: ({ signal }) => {
      const getDeviceReq = api.ecg.getDevice(pointer);
      applySignal(getDeviceReq, signal);

      return getDeviceReq.result;
    },
  });
}
